import type { DatepickerProps } from './types'

export const getNestedValue = (obj = {}, keyPath = '') =>
  keyPath.split('.').reduce((subObject, nextKey) => subObject?.[nextKey], obj)

export const getMode = ({
  showYearPicker,
  showMonthYearPicker,
}: Pick<DatepickerProps, 'showMonthYearPicker' | 'showYearPicker'>) => {
  if (showYearPicker) {
    return 'year'
  }
  if (showMonthYearPicker) {
    return 'month'
  }
  return 'custom'
}

export const getFirstAndLastDayOfYear = (date: Date) => {
  let _date = date
  if (!_date) {
    _date = new Date()
  }

  const year = _date.getFullYear()
  const firstDay = new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0))
  const lastDay = new Date(Date.UTC(year + 1, 0, 0, 23, 59, 59, 0))

  return [firstDay, lastDay]
}
export const getFirstAndLastDayOfMonth = (date: Date) => {
  let _date = date
  if (!_date) {
    _date = new Date()
  }

  const year = _date.getFullYear()
  const month = _date.getMonth()
  const firstDay = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0))
  const lastDay = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 0))

  return [firstDay, lastDay]
}

export const getFirstAndLastDayForLastNDays = (n: number) => {
  const endDate = new Date()

  const startDate = new Date(endDate)
  startDate.setUTCDate(startDate.getUTCDate() - n)

  startDate.setUTCHours(0, 0, 0, 0)
  endDate.setUTCHours(23, 59, 59, 999)

  return [startDate, endDate]
}

export const getFirstAndLastDayForLastYear = () => {
  const endDate = new Date()
  endDate.setUTCHours(23, 59, 59, 999)

  const startDate = new Date(
    Date.UTC(
      endDate.getUTCFullYear(),
      endDate.getUTCMonth() - 12,
      endDate.getUTCDate(),
      0,
      0,
      0,
      0
    )
  )

  return [startDate, endDate]
}
